import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { CTALink } from '@components/CTALink';

export const DisplayAboveMobile = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DisplayOnMobile = styled(Box)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledText = styled(Text)`
  width: 64%;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledCTALink = styled(CTALink)`
  color: ${themeColor('neutra6')};
`;
